import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Inject, Optional } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from '../../api.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { FileUploaderComponent } from '../../mailbox/file-uploader/file-uploader.component';
import { datePickerMinDate, disclaimer, getStringSizeInBytes, MAIL_SIGNATURE, maxMailSizeMB } from '../../shared/constants';
import { NavbarComponent } from '../../navbar/navbar.component';
import moment from 'moment';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import FileSaver from 'file-saver';
declare var $: any;

@Component({
	selector: 'app-send-report',
	templateUrl: './send-report.component.html',
	styleUrls: ['./send-report.component.scss', '../../../assets/styles/mailbox.scss'],
})
export class SendReportComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('fileUploaderComponent') fileUploaderComponent!: FileUploaderComponent;
	items: any = [];
	showLoader = false;
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	form: FormGroup = this.fb.group({
		mail: [null]
	});
	uId: any = null;
	followId: any = null;
	selectedMail: any = null;
	mailList: any[] = [];
	isListLoading = false;
	viewMail: any = null;
	showMailLoader = false;
	isReply = false;
	mailSignature = MAIL_SIGNATURE;
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	followUpDetails: any = null;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	downloadLoader = false;
	pagetitle: string = "Follow-up Report";
	moduleForm!: FormGroup;
	minDate = datePickerMinDate;
	formSubmitted = false;
	saveLoader = false;
	showReport = false;
	fileURL: any = null;
	prevFollList: any[] = [];

	constructor(private sanitizer: DomSanitizer, private formBuilder: FormBuilder, private activeRoute: ActivatedRoute, private fb: FormBuilder, private toastr: ToastrService, private apiService: ApiService, private router: Router, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.resetForm();
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["caseId"];
			this.followId = routeParams["followId"];
			try {
				this.uId = decodeURIComponent(this.uId);
			} catch (e) { }
			try {
				this.followId = decodeURIComponent(this.followId);
			} catch (e) { }
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/" + this.followId, name: "Appointment Details", queryparams: { "follow-up": this.followId } });
			this.breadcrumbList.push({ path: "/app/followup-report/" + this.uId + "/" + this.followId, name: "Send Report" });
			this.getCaseMails();
			this.getDetails();
			this.getReportPDF();
			this.apiService.userData$.subscribe((user) => {
				if (user) {
					this.mailSignature = user.email_signature || MAIL_SIGNATURE;
				}
			})
			/* this.confirmReportType(); */
		});
	}

	getCaseMails() {
		this.isListLoading = true;
		let data: any = {
			event_id: this.uId,
		}
		this.apiService.getMails(data).subscribe({
			next: (data: any) => {
				try {
					let mails: any = data.data;
					for (var i = 0; i < mails.length; ++i) {
						mails[i] = this.processMail(mails[i]);
					}
					this.mailList = mails.filter((mail: any) => mail.email_status != 'draft');
				} catch (error) {
					this.toastr.error("Something went wrong", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
				this.isListLoading = false;
			}, error: (error) => {
				this.isListLoading = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getMailDetails() {
		this.isReply = false;
		this.viewMail = null;
		if (this.selectedMail) {
			this.showMailLoader = true;
			this.apiService.getMails({ id: this.selectedMail }).subscribe({
				next: (data: any) => {
					this.showMailLoader = false;
					this.viewMail = data;
				}, error: (error) => {
					this.showMailLoader = false;
					this.toastr.error("Something went wrong", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		}
	}

	mail_html_fetched(mail: any) {
		this.viewMail = mail;
		this.showReply();
	}

	showReply() {
		this.isReply = true;
		const mail: any = this.bindCommonInputs();
		mail.body = this.mailSignature;
		if (this.viewMail?.email_status == 'read' || this.viewMail?.email_status == 'unread') {
			mail.toMail.push(this.viewMail.from_email);
		}
		if (this.viewMail.from_email !== null) {
			let emailExists = false;
			for (var i = 0; i < mail.toMail.length; i++) {
				if (mail.toMail[i] == this.viewMail.from_email) {
					emailExists = true;
				}
			}
			if (!emailExists) {
				mail.toMail.push(this.viewMail.from_email.trim());
			}
		}
		for (var i = 0; i < mail.toMail.length; i++) {
			if (mail.toMail[i] == environment.email_id) {
				mail.toMail.splice(i, 1);
				break;
			}
		}
		this.form.get('mail')?.patchValue(mail);
	}

	bindCommonInputs() {
		const mail: any = {};
		mail.subject = this.viewMail.subject;
		mail.ccMail = [];
		if (this.viewMail.ccArr && this.viewMail.ccArr.length > 0) {
			for (var i = 0; i < this.viewMail.ccArr.length; ++i) {
				mail.ccMail.push(this.viewMail.ccArr[i]);
			}
		}
		mail.toMail = [];
		if (this.viewMail.toMailArr && this.viewMail.toMailArr.length > 0) {
			for (var i = 0; i < this.viewMail.toMailArr.length; i++) {
				mail.toMail.push(this.viewMail.toMailArr[i]);
			}
		}
		return mail;
	}

	getInitials(name: string) {
		if (name) {
			try {
				let nameArr: any[] = name.split(" ");
				for (let i = 0; i < nameArr.length; i++) {
					nameArr[i] = nameArr[i][0];
				}
				return nameArr.join("");
			} catch (error) {
				return name;
			}
		} else {
			return "";
		}
	}

	processMail(mail: any) {
		try {
			let toEmails: any = mail.to_email;
			mail.toEmailList = JSON.parse(toEmails);
		} catch (error) { }
		try {
			if (typeof mail.attachment_url == "string") {
				mail.attachmentsArr = JSON.parse(mail.attachment_url);
			} else {
				mail.attachmentsArr = mail.attachment_url || [];
			}
		} catch (error) {
			mail.attachmentsArr = [];
		}
		mail.messageDate = moment.parseZone(mail.message_date).format("DD-MM-YYYY HH:mm");
		return mail;
	}

	emailPatternValidator(control: FormControl) {
		const regex = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,5}$/;
		if (!control.value.match(regex)) {
			return {
				'emailerr': true
			};
		}
		return null;
	}

	ngAfterViewInit() { }

	ngOnDestroy() {
		$('[id*="richtexteditor"]').hide();
	}

	report_url: any;
	saveMail(action: string) {
		let err: String[] = [];
		if (!this.form.value.mail.toMail || !this.form.value.mail.toMail.length) {
			err.push("To");
		}
		if (!this.form.value.mail.subject) {
			err.push("Subject");
		}
		if (!this.form.value.mail.body) {
			err.push("Body");
		}
		if (err.length) {
			this.toastr.info("Please provide " + err.join(", "), 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let attachment = this.fileUploaderComponent.getAttachments();
		if (!this.report_url || !attachment.length) {
			this.toastr.info("Report should be attached to send", 'No Report', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let cc: any = this.form.value.mail.ccMail;
		if (cc == null) {
			cc = [];
		}
		let mailContent = this.form.value.mail.body;
		const container = document.createElement('div');
		container.innerHTML = mailContent;
		const cells = container.querySelectorAll('th, td');
		cells.forEach((cell) => {
			if (cell instanceof HTMLElement) {
				cell.style.border = '1px solid black';
			}
		});
		mailContent = container.innerHTML;
		let mailObj: any = {};
		mailObj["to"] = JSON.stringify(this.form.value.mail.toMail);
		mailObj["cc"] = JSON.stringify(cc);
		mailObj["subject"] = this.form.value.mail.subject;
		mailObj["attachment"] = JSON.stringify(attachment);
		let successMsg = "";
		let pathAfterSuccess = "";
		if (action == "update_draft") {
			mailObj["id"] = this.viewMail.id;
			mailObj["reply_id"] = this.viewMail.reply_id;
			mailObj["email_status"] = "draft";
			if (this.viewMail.reply_id) {
				mailObj["content"] = mailContent + '<span id="mailSeparator" style="display:none;"></span>' + this.viewMail.body_html;
			} else {
				mailObj["content"] = mailContent;
			}
			successMsg = "Draft updated successfully";
			pathAfterSuccess = "draft";
		} else if (action == "compose_mail") {
			mailObj["id"] = this.viewMail.id;
			mailObj["reply_id"] = this.viewMail.reply_id;
			mailObj["email_status"] = "sent";
			if (this.viewMail.reply_id) {
				mailObj["content"] = mailContent + '<span id="mailSeparator" style="display:none;"></span>' + this.viewMail.body_html + disclaimer;
			} else {
				mailObj["content"] = mailContent + disclaimer;
			}
			successMsg = "Mail sent successfully";
			pathAfterSuccess = "outgoing";
		} else if (action == "save_reply_draft") {
			mailObj["reply_id"] = this.viewMail.id;
			mailObj["email_status"] = "draft";
			mailObj["content"] = mailContent + this.getForward() + this.viewMail.body_html;
			successMsg = "Draft saved successfully";
			pathAfterSuccess = "draft";
		} else if (action == "mail_reply_message") {
			mailObj["reply_id"] = this.viewMail.id;
			mailObj["email_status"] = "sent";
			mailObj["content"] = mailContent + this.getForward() + this.viewMail.body_html + disclaimer;
			successMsg = "Mail sent successfully";
			pathAfterSuccess = "outgoing";
		}
		if (this.viewMail.event_id) {
			mailObj.event_id = this.viewMail.event_id;
		}
		let totalSize = getStringSizeInBytes(mailObj["content"]);
		for (let i = 0; i < attachment.length; i++) {
			totalSize += attachment[i].size;
		}
		let sizeInMB = totalSize / 1024 / 1024;
		if (sizeInMB >= maxMailSizeMB) {
			this.toastr.error("Mail size exceeds " + maxMailSizeMB + "MB", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.showMailLoader = true;
		this.apiService.saveMail(mailObj).subscribe({
			next: (data) => {
				const payload = {
					"id": this.followId,
					"report_pdf": this.report_url.replace(/^https?:\/\/[^\/]+\//, "")
				}
				this.apiService.saveReportDetils(payload).subscribe({
					next: (data: any) => {
						this.showMailLoader = false;
						this.toastr.success(successMsg, 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error) => {
						this.showMailLoader = false;
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
				this.router.navigate(['/app/appt-details', 'no', this.uId, this.followId, 'mails']);
			}, error: (error) => {
				this.showMailLoader = false;
				if (typeof error.error == "string") {
					this.toastr.error(error.error, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				} else {
					this.toastr.error("Something went wrong.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	getForward() {
		let to_email = '';
		if (this.viewMail.toMailArr && this.viewMail.toMailArr.length > 0) {
			for (let i = 0; i < this.viewMail.toMailArr.length; i++) {
				to_email += "<a href=\"mailto:" + this.viewMail.toMailArr[i] + "\">" + this.viewMail.toMailArr[i] + "</a>; \n";
			}
		}
		let cc_email = '';
		if (this.viewMail.ccArr && this.viewMail.ccArr.length > 0) {
			for (let i = 0; i < this.viewMail.ccArr.length; i++) {
				cc_email += "<a href=\"mailto:" + this.viewMail.ccArr[i] + "\">" + this.viewMail.ccArr[i] + "</a>; \n";
			}
			cc_email = "<strong>CC: " + cc_email + "<br /> \n";
		}
		let forward = '<span id="mailSeparator" style="display:none;"></span>&nbsp;</br><hr />' +
			"<p><strong>From: </strong><a href=\"mailto:" + this.viewMail.from_email + "\">" + (this.viewMail.from_name || this.viewMail.from_email) + "</a><br /> \n" +
			"<strong>Sent: </strong>" + this.viewMail.messageDate + "<br /> \n" +
			"<strong>TO: " + to_email + "</strong> <br /> \n" +
			cc_email +
			"<strong>Subject: </strong>" + this.viewMail.subject + "</p>";
		return forward;
	}

	getPrevFollowUps() {
		this.pageLoading1 = true;
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.prevFollList = data.data.filter((fol: any) => {
					try {
						if (fol.enc_id == this.followId) {
							return false;
						}
						let currFolDate = this.apiService.getDateFromDateString(this.followUpDetails.follow_up_date);
						let folDate = this.apiService.getDateFromDateString(fol.follow_up_date);
						if (currFolDate >= folDate && fol.follow_up_status && fol.follow_up_status.id != 1 && fol.visit_type && fol.visit_type.id != 5) {
							return true;
						}
						return false;
					} catch (error) {
						return false;
					}
				});
			}, error: (error) => {
				this.pageLoading1 = false;
				this.prevFollList = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getFollowUpStatusClass(statusId: any) {
		if (statusId == 2) {
			return "bg-success";
		} else if (statusId == 1) {
			return "bg-warning";
		} else {
			return "bg-danger";
		}
	}

	resetForm() {
		this.moduleForm = this.formBuilder.group({
			/* expected_treatment_period: [null],
			expected_treatment_cost: [null], */
			further_advice: [null],
			brief_history: [null],
			/* fitness_status: [null], */
			report_no: [null/* , [Validators.required, Validators.pattern(/^\d+$/)] */],
			/* next_review_date: [null], */
			/* due_to: [null], */
			previous_followups: [[]],
			followup_report_sent: [false],
			faq: this.formBuilder.array([])
			/* doctor_1_id: [null, [Validators.required]],
			doctor_2_id: [null, [Validators.required]] */
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['faq'] as FormArray;
	}

	addRow(valueObj: any = null) {
		const form = this.formBuilder.group({
			id: [valueObj?.id || null, [Validators.required]],
			question: [valueObj?.question || null, [Validators.required]],
			answer: [valueObj?.answer || null]
		});
		this.get_rows.push(form);
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	getDetails() {
		this.pageLoading2 = true;
		this.apiService.getFollowupDetails(this.followId).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.followUpDetails = data.data;
				this.resetForm();
				/* this.f.expected_treatment_period.setValue(this.followUpDetails.expected_treatment_period);
				this.f.expected_treatment_cost.setValue(this.followUpDetails.expected_treatment_cost); */
				this.f.further_advice.setValue(this.followUpDetails.further_advice);
				this.f.brief_history.setValue(this.followUpDetails.brief_history);
				/* this.f.fitness_status.setValue(this.followUpDetails.fitness_status); */
				/* this.f.due_to.setValue(this.followUpDetails.due_to); */
				this.f.previous_followups.setValue(this.followUpDetails.previous_followups);
				this.f.followup_report_sent.setValue(this.followUpDetails.followup_report_sent);
				this.f.report_no.setValue(this.followUpDetails.report_no);
				/* this.f.next_review_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.next_review_date)); */
				let faq = this.followUpDetails.faq;
				let len = this.followUpDetails.faq.length;
				for (let i = 0; i < len; i++) {
					this.addRow(faq[i]);
				}
				if (this.navbar.userAccess?.Follow_up_report != 'Full') {
					this.moduleForm.disable();
				}
				this.getPrevFollowUps();
			}, error: (error) => {
				this.pageLoading2 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveReport_A() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required fields", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.saveReport_B();
		/* const followup = this.getChangedFollowupNotes();
		if (followup.length) {
			this.otpVerification();
		} else {
			this.saveReport_B();
		} */
	}

	saveReport_B() {
		let payload: any = {
			id: this.followId,
			/* expected_treatment_period: this.f.expected_treatment_period.value,
			expected_treatment_cost: this.f.expected_treatment_cost.value, */
			further_advice: this.f.further_advice.value,
			brief_history: this.f.brief_history.value,
			/* fitness_status: this.f.fitness_status.value, */
			/* due_to: this.f.due_to.value, */
			previous_followups: this.f.previous_followups.value,
			followup_report_sent: this.f.followup_report_sent.value,
			report_no: this.f.report_no.value,
			/* next_review_date: this.apiService.getDateStringFromDate(this.f.next_review_date.value) || null */
		}
		let faq: any[] = [];
		for (let i = 0; i < this.get_rows.controls.length; i++) {
			faq.push({
				id: this.get_rows.controls[i].get("id")?.value,
				question: this.get_rows.controls[i].get("question")?.value,
				answer: this.get_rows.controls[i].get("answer")?.value
			});
		}
		payload.faq = faq;
		this.saveLoader = true;
		this.apiService.saveFollowUpReport(payload).subscribe({
			next: (data: any) => {
				this.saveLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getDetails();
				this.getReportPDF();
			}, error: (error) => {
				this.saveLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	downloadReport() {
		this.getReportPDF(true);
	}

	reportFile!: File;
	getReportPDF(isDownload = false) {
		if (isDownload) {
			this.downloadLoader = true;
		} else {
			this.pageLoading3 = true;
		}
		this.apiService.followUpReportPDF({ "id": this.followId/* , "flag": isDownload */ }).subscribe({
			next: (data: any) => {
				let blob = new Blob([data.body], { type: "application/pdf" });
				this.apiService.getFollowupDetails(this.followId).subscribe({
					next: (follData: any) => {
						const f_name = follData.data.case_id.candidate.f_name;
						const l_name = follData.data.case_id.candidate.l_name;
						let report_no = follData.data.report_no;
						if (report_no) {
							if (!isNaN(report_no)) {
								report_no = "Report - " + report_no;
							}
						} else {
							report_no = "";
						}
						let file_name = report_no + " - " + f_name + " " + l_name + ".pdf";
						this.reportFile = new File([blob], file_name, {
							type: blob.type,
							lastModified: new Date().getTime()
						});
						if (isDownload) {
							FileSaver.saveAs(blob, file_name);
							this.downloadLoader = false;
						} else {
							this.pageLoading3 = false;
							this.showReport = true;
							this.fileURL = this.getSafeUrl(URL.createObjectURL(blob) + "#toolbar=0");
						}
					}, error: (error) => {
						if (isDownload) {
							this.downloadLoader = false;
						} else {
							this.pageLoading3 = false;
							this.showReport = false;
						}
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}, error: (error) => {
				if (isDownload) {
					this.downloadLoader = false;
				} else {
					this.pageLoading3 = false;
					this.showReport = false;
				}
				this.showErrorPopup(error, isDownload);
			}
		});
	}

	showErrorPopup(error: any, isDownload: boolean) {
		if (error.status == 400) {
			let msg = "Please save report details to generate report.";
			if (isDownload) {
				this.toastr.error(msg, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			} else {
				Swal.fire({ title: "Note", text: msg });
			}
		} else {
			this.toastr.error("Unable to fetch report", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	attachReport() {
		this.fileUploaderComponent.addReportToQueue(this.reportFile);
	}

	reportAttached(file_url: any) {
		this.report_url = file_url;
	}
}